import React, { FC } from 'react';

import st from './Address.module.css';

type AddressProps = {
  address: AddressTypeProps;
  isClosed?: boolean;
  isDetailed?: boolean;
};

const Address: FC<AddressProps> = ({
  address,
  isDetailed = false,
  isClosed = false,
}) =>
  isClosed ? (
    <p className={isDetailed ? st.addressDetailedClosed : st.addressClosed}>
      {address.value}
    </p>
  ) : (
    <p className={isDetailed ? st.addressDetailed : st.address}>
      {address.value}
    </p>
  );

export default Address;
